

export class FacebookConnectionTrackingCommandVO {

    /**
     * Facebook connection state. Possible values are in FacebookConnectionConst class
     */
    public facebookConnectionState: string;

    /**
     * Level of the player
     */
    public gameLevel: number;

    /**
     * Facebook Id
     */
    public facebookId: string;

}

